import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable } from '@nurhanna/react-bootstrap-table';
import swal from 'sweetalert';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { getFilteredData, showLoadingSpinner } from '../api/fetchApi';
import { resetDataError, resetError } from '../actions/resetAction';
import { logoutUser } from '../api/authenticationApi';
import { DATA_ERROR_MSG, ERROR_MSG } from '../constants/actionTypes';
import AlacrityTable from './AlacrityTable';
import Spinner from './Spinner';
import JsonApi from '../helpers/json_api.js';
import { settingAr, settingDarkTable, settingEn } from '../helpers/translations/cssClassHelper';
import { getLS, removeLS, setLS } from '../helpers/utils';

class DataLoader extends AlacrityTable {
  constructor(props) {
    super(props);

    const staticFilters = this.props.apiParams ? ({ ...this.props.apiParams.filter }) : {};

    this.state = {
      data: [],
      totalDataSize: 0,
      sizePerPage: 10,
      page: 1,
      currentPage: 1,
      errors: {},
      currentFilter: staticFilters,
      dataLoadErrors: {},
      unsubscribe: [],
      masterFilter: {},
      resetUnsub: null,

    };

    this.unsubDatas = [];
    this.columns = this.props.columns;
    this.onPageChange = this.onPageChange.bind(this);
    this.onSizePerPageChange = this.onSizePerPageChange.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.noDataText = this.noDataText.bind(this);
    this.refreshData = this.refreshData.bind(this);
  }

  fetchData(apiURL, filters, pageSize, pageNumber, sortOrder, sortField, apiAction) {
    const data = {
      apiURL,
      filters,
      page: {
        size: pageSize,
        number: pageNumber,
      },
      sortField,
      sortOrder,
      apiAction,
    };
    this.props.getFilteredData(data);
  }

  refreshData() {
    this.fetchData(this.props.apiUrl, this.state.currentFilter, this.state.sizePerPage, this.state.page, this.state.sortOrder, this.state.sortField);
  }

  // componentWillMount - original design to load data based on msisdn, but currently pull all the subs first
  componentDidMount() {
    const checkExistingLocalStorage = JSON.parse(getLS('unsubDatas'));
    if (!_.isEmpty(checkExistingLocalStorage)) {
      removeLS('unsubDatas');
    }

    this.props.showLoadingSpinner();
    if (!this.props.isLogout2) {
      this.fetchData(this.props.apiUrl, this.state.currentFilter, this.state.sizePerPage, this.state.page, this.state.sortOrder, this.state.sortField);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const iLang = this.props.i18n.language;
    if (iLang) {
      if (iLang === 'ar') {
        settingAr(this.props.i18n);
      }
      if (iLang === 'en') {
        settingEn(this.props.i18n);
      }
    }

    if (nextProps.apiParams && nextProps.apiParams !== this.props.apiParams) {
      // appends
      const staticFilters = { ...this.state.currentFilter };
      const newFilters = { ...staticFilters, ...nextProps.apiParams };

      Object.keys(newFilters).map((k) => {
        if (typeof newFilters[k] === 'object') {
          if (newFilters[k].value === -1) {
            delete newFilters[k];
          }

          return newFilters[k];
        } if (newFilters[k] === '-1') {
          delete newFilters[k];
        }

        return newFilters[k];
      });
      this.setState({ currentFilter: newFilters, currentPage: 1, masterFilter: newFilters });
      this.fetchData(this.props.apiUrl, newFilters, this.state.sizePerPage, this.state.currentPage, this.state.sortOrder, this.state.sortField);
    }

    if (nextProps.errors) {
      if ((nextProps.errors !== this.state.errors) && (nextProps.errors === ERROR_MSG)) {
        swal("An error had occured or you don't have permission to view this page");
        this.props.resetError();
        this.props.logoutUser(this.props.history);
      }

      if ((nextProps.errors !== this.state.errors) && (nextProps.errors === 'NOHEADER')) {
        swal('You have successfully logged out');
        this.props.resetError();
        this.props.logoutUser(this.props.history);
      }

      if (nextProps.errors.dataLoadError) {
        if ((nextProps.errors.dataLoadError !== this.state.dataLoadError) && (nextProps.errors.dataLoadError === DATA_ERROR_MSG)) {
          swal('Oops! No data available')
            .then((value) => {
              this.props.resetDataError();
              window.location.reload();
            });
        }

        if ((nextProps.errors.dataLoadError !== this.state.dataLoadError) && (nextProps.errors.dataLoadError === 'Server Error')) {
          swal('Oops! An error had occurred on server side')
            .then((value) => {
              this.props.resetDataError();
            });
        }
      }
    }

    if (nextProps.data && (nextProps.data !== this.state.data)) {
      const tempData = nextProps.data;
      const checkLocalStorage = JSON.parse(getLS('unsubDatas'));

      if ((Array.isArray(this.unsubDatas) || !this.unsubDatas.length) && !_.isEmpty(checkLocalStorage)) {
        this.unsubDatas.push(checkLocalStorage.unsubid);
      }

      const checkUnsubRowID = checkLocalStorage || this.unsubDatas;
      if (checkUnsubRowID) {
        // eslint-disable-next-line array-callback-return
        tempData.map((row) => {
          if (checkLocalStorage) {
            const matchId = checkLocalStorage.find((item) => item === row.id);
            if (matchId) {
              // eslint-disable-next-line no-param-reassign
              row.status = 'deleted';
            }
          }
        });
      }
      this.setState({ data: tempData });
    }

    if (nextProps.unsubscribe && (nextProps.unsubscribe !== this.state.unsubscribe)) {
      this.setState({ unsubscribe: nextProps.unsubscribe });
      const tempData = this.state.data;
      const tempNewRow = nextProps.unsubscribe;
      // eslint-disable-next-line array-callback-return
      tempData.map((row) => {
        if (row.id === tempNewRow.id) {
          // eslint-disable-next-line no-param-reassign
          row.status = 'deleted';
          this.unsubDatas.push(tempNewRow.id);
          const checkExistingLocalStorage = JSON.parse(getLS('unsubDatas'));
          if (!_.isEmpty(checkExistingLocalStorage)) {
            checkExistingLocalStorage.push(tempNewRow.id);
            setLS('unsubDatas', JSON.stringify(checkExistingLocalStorage));
          } else {
            setLS('unsubDatas', JSON.stringify(this.unsubDatas));
          }
        }
      });
    }

    if (nextProps.resetUnsub && (nextProps.resetUnsub !== this.state.resetUnsub)) {
      const tempData = this.state.data;
      const tempNewRow = nextProps.resetUnsub;
      // eslint-disable-next-line array-callback-return
      tempData.map((row) => {
        if (row.id === tempNewRow.id) {
          // eslint-disable-next-line no-param-reassign
          row.status = 'action_cancel';
        }
      });
      this.setState({ resetUnsub: nextProps.resetUnsub });
    }
  }

  // created deleted cancelled purged failed
  onPageChange(page, sizePerPage) {
    this.fetchData(this.props.apiUrl, this.state.currentFilter, sizePerPage, page, this.state.sortOrder, this.state.sortField);
    this.setState({ currentPage: page, sizePerPage });
  }

  onSizePerPageChange(sizePerPage) {
    // When changing the size per page always navigating to the first page
    this.fetchData(this.props.apiUrl, this.state.currentFilter, sizePerPage, 1, this.state.sortOrder, this.state.sortField);
  }

  onFilterChange(filterObj, colInfos) {
    let key = [];

    if (filterObj) {
      // eslint-disable-next-line array-callback-return
      Object.keys(filterObj).map((k) => {
        if (typeof filterObj[k] === 'object') {
          // eslint-disable-next-line no-unused-expressions
          filterObj[k].value && filterObj[k].value.key ? key = filterObj[k].value.key : key = k;
          // eslint-disable-next-line no-param-reassign
          filterObj[key] = this.resolveFilter(filterObj[k], colInfos, k);
          if (k !== key) {
            // eslint-disable-next-line no-param-reassign
            delete filterObj[k];
          }

          return filterObj[key];
        }
      });
    }

    const { apiParams } = this.props;
    if (apiParams) {
      Object.keys(apiParams).map((k) => {
        if (typeof apiParams[k] === 'object') {
          apiParams[k] = this.resolveFilter(apiParams[k], null, k);
        }

        return apiParams[k];
      });
    }

    if (_.isEmpty(filterObj)) {
      // remove the filter
      const staticFilters = this.state.currentFilter;
      this.setState({ currentFilter: this.state.masterFilter, currentPage: 1 });
      this.fetchData(this.props.apiUrl, this.state.masterFilter, this.state.sizePerPage, this.state.currentPage, this.state.sortOrder, this.state.sortField);
    } else if (this.props.apiParams) {
      if (this.props.apiParams.filter) {
        const staticFilters = this.props.apiParams.filter;// this.state.currentFilter;
        const newFilters = { ...staticFilters, ...filterObj };
        this.setState({ currentFilter: newFilters, currentPage: 1 });
        this.fetchData(this.props.apiUrl, newFilters, this.state.sizePerPage, this.state.currentPage, this.state.sortOrder, this.state.sortField);
      } else {
        const staticFilters = this.state.masterFilter ? this.state.masterFilter : this.state.currentFilter;// this.props.apiParams;//this.state.currentFilter;
        const newFilters = { ...staticFilters, ...filterObj };
        this.setState({ currentFilter: newFilters, currentPage: 1 });
        this.fetchData(this.props.apiUrl, newFilters, this.state.sizePerPage, this.state.currentPage, this.state.sortOrder, this.state.sortField);
      }
    }
  }

  onSortChange(sortName, sortOrder) {
    this.fetchData(this.props.apiUrl, this.state.currentFilter, this.state.sizePerPage, 1, sortOrder, sortName);
    this.setState({ sortField: sortName, sortOrder });
  }

  resolveFilter(filterValue, colInfos, key) {
    // eslint-disable-next-line default-case
    switch (filterValue.type) {
      case 'TextFilter':
        if (colInfos && colInfos[key].formatExtraData.filter.case === 'upper') {
          // eslint-disable-next-line no-param-reassign
          filterValue = filterValue.value.toUpperCase();
        } else if (colInfos && colInfos[key].formatExtraData.filter.case === 'lower') {
          // eslint-disable-next-line no-param-reassign
          filterValue = filterValue.value.toLowerCase();
        } else {
          // eslint-disable-next-line no-param-reassign
          filterValue = filterValue.value;
        }
        break;
      case 'NumberFilter':
        // eslint-disable-next-line no-case-declarations
        const comparator = JsonApi.normlizeComparator(filterValue.value.comparator);
        // eslint-disable-next-line no-case-declarations
        const value = filterValue.value.number;
        // eslint-disable-next-line no-param-reassign
        filterValue = {};
        if (comparator) {
          // eslint-disable-next-line no-param-reassign
          filterValue[comparator] = value;
        } else {
          // eslint-disable-next-line no-param-reassign
          filterValue = value;
        }
        break;
      case 'RangeFilter':
        // eslint-disable-next-line no-case-declarations
        const fromComparator = JsonApi.normlizeComparator('>=');
        // eslint-disable-next-line no-case-declarations
        const toComparator = JsonApi.normlizeComparator('<=');
        // eslint-disable-next-line no-case-declarations
        const {fromValue} = filterValue.value;
        // eslint-disable-next-line no-case-declarations
        const {toValue} = filterValue.value;
        // eslint-disable-next-line no-param-reassign
        filterValue = {};
        // eslint-disable-next-line no-param-reassign
        filterValue[fromComparator] = fromValue;
        // eslint-disable-next-line no-param-reassign
        filterValue[toComparator] = toValue;
        break;
      case 'CustomFilter':
        // eslint-disable-next-line no-param-reassign
        filterValue = filterValue.value;

        return this.resolveFilter(filterValue);
    }

    return filterValue;
  }

  noDataText() {
    if (_.isEmpty(this.props.data)) {
      return (
        <div>
          <div>{this.props.t('no-data')}</div>
        </div>
      );
    }
    if (this.props.dataLoadError) {
      return (
        <div>
          <div>An error occurred while processing your request. Please press the refresh button below.</div>
          <div className="refresh-container">
            <button
              type="button"
              className="form form-group btn btn-primary btn-block"
              onClick={this.refreshData}
            >
              Refresh
            </button>
          </div>
        </div>
      );
    } if (this.props.loading) {
      return 'Loading...';
    }
  }

  render() {
    const cellEditProp = {
      mode: 'click',
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell,
    };

    settingDarkTable(getLS('dark') || this.props.changeTheme);

    return (
      <>
        {this.props.loading ? <Spinner /> : null}
        <div className="myDataTable">
          <div className="myscrollContainer">
            <div className="table-responsive">
              <BootstrapTable
                // ignoreSinglePage
                tableStyle={getLS('dark') === 'true' || this.props.changeTheme === 'true' ? { backgroundColor: '#2e3d4c', borderColor: 'gray', color: 'white !important' } : { backgroundColor: 'white', color: '#212529' }}
                wrapperClasses="table-responsive"
                id={this.props.id}
                data={this.props.data || this.state.data}
                remote
                striped
                hover
                height="auto"
                pagination
                fetchInfo={{ dataTotalSize: this.props.totalDataSize }}
                options={{
                  sizePerPage: this.state.sizePerPage,
                  withFirstAndLast: false,
                  onPageChange: this.onPageChange,
                  sizePerPageList: [5, 10, 20],
                  page: this.state.currentPage,
                  onSizePerPageList: this.onSizePerPageChange,
                  onFilterChange: this.onFilterChange,
                  onSortChange: this.onSortChange,
                  noDataText: this.noDataText(),
                }}
              >
                {this.renderTableColumns()}
              </BootstrapTable>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.subs.data,
  totalDataSize: state.subs.totalDataSize,
  errors: state.errors,
  dataLoadError: state.dataLoadError,
  loading: state.subs.loading,
  isLogout: state.auth.isLogout,
  isLogout2: state.subs.isLogout,
  unsubscribe: state.unsubs.unsubscribe,
  resetUnsub: state.unsubs.resetUnsub,

});

const mapDispatchToProps = (dispatch) => ({
  resetError: () => dispatch(resetError()),
  resetDataError: () => dispatch(resetDataError()),
  showLoadingSpinner: () => dispatch(showLoadingSpinner()),
  getFilteredData: (data) => dispatch(getFilteredData(data)),
  logoutUser: (history) => dispatch(logoutUser(history)),
});

export default withTranslation('lang')(withRouter(connect(mapStateToProps, mapDispatchToProps)(DataLoader)));
